import { environment } from "../../../environments/environment";

export const appPlanningConstantsUrl = {
  optimizer: {
    order: {
      getExcludedList: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Order/GetExcludedList',
      getExcludedListSimple: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Order/GetExcludedListSimple',
      getList: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Order/GetList',
      getMetadata: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Domain/CreateModel',
      getSessionList: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Order/GetSessionList',
    },
    request: {
      consolidate: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Request/Consolidate',
      delete: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Request/Delete',
      get: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Request/Get',
      getKeyDescriptionList: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Request/GetKeyDescriptionList',
      getList: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Request/GetList',
      getListFiltered: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Request/GetListFiltered',
      getMetadata: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Domain/CreateModel',
      getSolution: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Request/GetSolution',
      insert: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Request/Insert',
      new: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Request/New',
      reset: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Request/Reset',
      update: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Request/Update'
    } as IAppConstantsCrudUrl,
    trip: {
      getList: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Trip/GetList',
      getMetadata: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Domain/CreateModel',
      getRoute: environment.appSettings.apiBaseAddress + '/Planning-Optimizer/Trip/GetRoute',
    }
  },
  order: {
    delete: environment.appSettings.apiBaseAddress + '/Planning/Order/Delete',
    get: environment.appSettings.apiBaseAddress + '/Planning/Order/Get',
    getChangeLogList: environment.appSettings.apiBaseAddress + '/Planning/Order/GetChangeLogList',
    getKeyDescriptionList: undefined,
    getList: environment.appSettings.apiBaseAddress + '/Planning/Order/GetList',
    getListFiltered: environment.appSettings.apiBaseAddress + '/Planning/Order/GetListFiltered',
    insert: environment.appSettings.apiBaseAddress + '/Planning/Order/Insert',
    getMetadata: environment.appSettings.apiBaseAddress + '/Planning/Domain/CreateModel',
    new: environment.appSettings.apiBaseAddress + '/Planning/Order/New',
    statusList: environment.appSettings.apiBaseAddress + '/Planning/Order/GetStatusList',
    typeList: environment.appSettings.apiBaseAddress + '/Planning/Order/GetTypeList',
    update: environment.appSettings.apiBaseAddress + '/Planning/Order/Update'
  },
  transportUnit: {
    getList: environment.appSettings.apiBaseAddress + '/Planning/TransportUnit/GetList',
  },
  transportUnitAvailability: {
    getList: environment.appSettings.apiBaseAddress + '/Planning/TransportUnit-Availability/GetList',
    getListVehiclesOnTrip: environment.appSettings.apiBaseAddress + '/Planning/TransportUnit-Availability/GetListVehiclesOnTrip',
    perZoneCount: environment.appSettings.apiBaseAddress + '/Planning/TransportUnit-Availability/PerZoneCount',
    set: environment.appSettings.apiBaseAddress + '/Planning/TransportUnit-Availability/Set',
  },
  trip: {
    delete: environment.appSettings.apiBaseAddress + '/Planning/Trip/Delete',
    deliveryChangeLogList: environment.appSettings.apiBaseAddress + '/Planning/Trip/DeliveryChangeLogList',
    execute: environment.appSettings.apiBaseAddress + '/Planning/Trip/Execute',
    executeList: environment.appSettings.apiBaseAddress + '/Planning/Trip/ExecuteList',
    executeUpdate: environment.appSettings.apiBaseAddress + '/Planning/Trip/ExecuteUpdate',
    get: environment.appSettings.apiBaseAddress + '/Planning/Trip/Get',
    getChangeLogList: environment.appSettings.apiBaseAddress + '/Planning/Trip/GetChangeLogList',
    getKeyDescriptionList: environment.appSettings.apiBaseAddress + '/Planning/Trip/GetKeyDescriptionList',
    getKeyDescriptionListFiltered: environment.appSettings.apiBaseAddress + '/Planning/Trip/GetKeyDescriptionListFiltered',
    getList: environment.appSettings.apiBaseAddress + '/Planning/Trip/GetList',
    getListFiltered: environment.appSettings.apiBaseAddress + '/Planning/Trip/GetListFiltered',
    getMetadata: environment.appSettings.apiBaseAddress + '/Planning/Domain/CreateModel',
    getRoutingTypes: environment.appSettings.apiBaseAddress + '/Planning/Trip/GetRoutingTypes',
    haulierAssign: environment.appSettings.apiBaseAddress + '/Planning/Trip/HaulierAssign',
    kmRecalculation: environment.appSettings.apiBaseAddress + '/Planning/Trip/KmRecalculation',
    insert: environment.appSettings.apiBaseAddress + '/Planning/Trip/Insert',
    new: environment.appSettings.apiBaseAddress + '/Planning/Trip/New',
    setSwapAccount: environment.appSettings.apiBaseAddress + '/Planning/Trip/SetSwapAccount',
    update: environment.appSettings.apiBaseAddress + '/Planning/Trip/Update'
  } as IAppConstantsCrudUrl,
  tripDensity: {
    delete: environment.appSettings.apiBaseAddress + '/Planning/TripDensity/Delete',
    get: environment.appSettings.apiBaseAddress + '/Planning/TripDensity/Get',
    getChangeLogList: environment.appSettings.apiBaseAddress + '/Planning/TripDensity/GetChangeLogList',
    getKeyDescriptionList: environment.appSettings.apiBaseAddress + '/Planning/TripDensity/GetKeyDescriptionList',
    getList: environment.appSettings.apiBaseAddress + '/Planning/TripDensity/GetList',
    getMetadata: environment.appSettings.apiBaseAddress + '/Planning/Domain/CreateModel',
    insert: environment.appSettings.apiBaseAddress + '/Planning/TripDensity/Insert',
    new: environment.appSettings.apiBaseAddress + '/Planning/TripDensity/New',
    update: environment.appSettings.apiBaseAddress + '/Planning/TripDensity/Update',
  } as IAppConstantsCrudUrl,
  tripOilCloudStatus: {
    getList: environment.appSettings.apiBaseAddress + '/Planning/Trip/TripOilCloudStatus',
  } as IAppConstantsCrudUrl
};

export const appPlanningConstants = {
  btnUrls: {
    executeList: "/planning/trip-historical/executelist-btn",
    kmRecalculation: "/planning/trip-historical/kmrecalculation-btn",
    kmRecalculationAll: "/planning/trip-historical/kmrecalculationall-btn",
    swapAccount: "/planning/trip-historical/swapaccount-btn"
  },
  optimizer: {
    status: {
      // Completato
      COMPLETED: 2,
      // In errore
      ERROR: -1,
      // Inserita
      INSERTED: 0,
      // In corso
      RUNNING: 1,
      // Viaggi generati
      TRIPGENERATED: 9
    }
  },
  signalr: {
    groups: {
      tripOptimizerNotification: "tripOptimizerNotification"
    },
    messageKey: {
      optimizerClientMessage: "OptimizerClientMessage"
    }
  },
  tripStatus: {
    completed: "C"
  }
}

export const appPlanningMetadataConstants = {
  request: environment.appSettings.apiNamespaceBase + 'Planning.Optimizer.EntitiesDTO.RequestDTO',
  transportUnitAvailability: environment.appSettings.apiNamespaceBase + 'Planning.EntitiesDTO.TransportUnitAvailabilityDTO',
  trip: environment.appSettings.apiNamespaceBase + 'Entity.Planning.Models.Trip',
  tripOilCloudStatus: environment.appSettings.apiNamespaceBase + 'Planning.EntitiesDTO.TripOilCloudStatusDTO'
};
